import React from 'react';

import { RulesDashboard } from '../../components/RulesDashboard';

function Dashboard() {
  return <RulesDashboard />;
}

export default Dashboard;
